import firebase from "firebase/app"
// If you are using v7 or any earlier version of the JS SDK, you should import firebase using namespace import
// import * as firebase from "firebase/app"
// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/storage"
import "firebase/functions"
import { firebaseConfig } from "./config"

firebase.initializeApp(firebaseConfig)

const getToken = firebase.functions().httpsCallable("getToken")

const updateExcel = firebase.functions().httpsCallable("updateExcel")

export { getToken, updateExcel }

export default firebase
